
import React from 'react'
import { connect } from 'react-redux'
import Col from 'muicss/lib/react/col'
import Paper from 'material-ui/Paper'
import Row from 'muicss/lib/react/row'
import Diamond from './Diamond'
import MissionState from './MissionState'
import { preSelectMission } from '../../../actions'
import { MISSION_STATE_EXPIRED, MISSION_STATE_LOCKED } from '../../../utils/constants'
import RemainingRepeats from '../RemainingRepeats'

const styles = {
  card: ((isSelected) => {
    if (isSelected) {
      return {
        cursor: 'pointer',
        backgroundColor: '#E3EFFF',
      }
    }
    return {
      paddingBottom: '15px',
      cursor: 'pointer',
    }
  }),
  root: {
    paddingBottom: '15px',
    cursor: 'pointer',
  },
  selectedRoot: {
    cursor: 'pointer',
    backgroundColor: '#E3EFFF',
  },
  content: (isSelected => ({
    borderRadius: '10px',
    padding: '10px',
    border: '1px solid #efefef',
    position: 'relative',
    minHeight: '100px',
    textAlign: 'center',
    backgroundColor: (isSelected ? '#E3EFFF' : '#ffffff'),
  })),
  lockedLayer: (locked => ({
    backgroundColor: (locked ? 'rgba(0,0,0,0.25)' : 'rgba(0,0,0,0)'),
    borderRadius: '10px',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  })),
  image: {
    margin: 'auto',
  },
  title: {
    fontWeight: 'bold',
  },
  description: {
    marginTop: '5px',
  },
  diamond: {
    height: '50px',
    width: 'auto',
  },
}

const locked = state =>
  ([MISSION_STATE_LOCKED, MISSION_STATE_EXPIRED].indexOf(state) !== -1)

class MissionIndex extends React.Component {


  onClick = this.props.preSelectMission(this.props)

  render() {
    const { credits, name, image_url, shortDescription, experience, isSelected } = this.props
    return (
      <Col xs="12" md="12" style={styles.root} onClick={this.onClick}>
        <Paper className="PaperHover" style={styles.content(isSelected)} zDepth={2} >
          <div style={styles.lockedLayer(locked(this.props.state))} />
          <Row style={{ position: 'relative' }}>
            <MissionState missionState={this.props.state} />
          </Row>
          <Row>
            <img src={image_url} alt={name} style={styles.image} />
          </Row>
          <Row style={styles.title}>
            {name}
          </Row>
          <Row style={styles.description}>
            {shortDescription}
            <RemainingRepeats {...this.props} />
          </Row>
          <Row>
            <Diamond credits={(credits||0).toLocaleString()} />
          </Row>
          <Row>
              EXP {(experience||0).toLocaleString()}
          </Row>
        </Paper>
      </Col>

    )
  }
}

MissionIndex.propTypes = {
  credits: React.PropTypes.number,
  name: React.PropTypes.string,
  image_url: React.PropTypes.string,
  shortDescription: React.PropTypes.string,
  experience: React.PropTypes.number,
  isSelected: React.PropTypes.bool,
  state: React.PropTypes.number,
  preSelectMission: React.PropTypes.func,
}


const mapStateToProps = state => ({
  
})

const mapDispatchToProps = dispatch => ({
  preSelectMission: mission => () => {
    dispatch(preSelectMission(mission))
  },
})


export default connect(mapStateToProps, mapDispatchToProps)(MissionIndex)



// WEBPACK FOOTER //
// ./src/components/CampaignShow/MissionIndex/index.jsx